import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-avatar-user',
  templateUrl: './avatar-user.component.html',
  styleUrls: ['./avatar-user.component.scss']
})
export class AvatarUserComponent implements OnInit {

  @Input() selectable: boolean;
  @Input() name: string;
  @Input() lastname: string;
  @Input() image: string;
  @Input() indexColor: number;
  @Input() width = 25;
  @Input() fontSize = '14px';
  colors = {
    a: '#f3a683',
    b: '#f7d794',
    c: '#778beb',
    d: '#e77f67',
    e: '#cf6a87',
    f: '#f19066',
    g: '#f5cd79',
    h: '#546de5',
    i: '#e15f41',
    j: '#c44569',
    k: '#786fa6',
    l: '#f8a5c2',
    m: '#63cdda',
    n: '#ea8685',
    o: '#574b90',
    p: '#f78fb3',
    q: '#3dc1d3',
    r: '#e66767',
    s: '#D6A2E8',
    t: '#BDC581',
    u: '#FC427B',
    v: '#D980FA',
    w: '#B53471',
    x: '#006266',
    y: '#EE5A24',
    z: '#1289A7'
  };
  constructor() { }

  ngOnInit(): void {
  }

}
